import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import VuexReset from '@ianwalter/vuex-reset'
import createCache from 'vuex-cache'

import registration from './modules/registration.store'
import commonEntities from './modules/common-entities.store'
import auth from './modules/auth.store'
import billing from './modules/billing.store'
import campaign from './modules/campaign.store'
import dashboard from './modules/dashboard.store'
import account from './modules/account.store'
import country from './modules/country.store'
import sellerOffer from './modules/sellerOffer.store'
import callLogs from './modules/call-logs.store'
import creative from './modules/creative.store'
import globalSettings from './modules/global-settings.store'
import onboarding from './modules/onboarding.store'
import verificationChecklist from './modules/verification-checklist.store'
import ringbaTokens from './modules/ringba-tokens.store'
import ringbaAccounts from './modules/ringba-accounts.store'
import ringTreeTargetRequest from './modules/ring-tree-target-request.store'
import sellerWebhooks from './modules/seller-webhooks.store'
import insights from './modules/insights.store'
import impersonation from './modules/impersonation.store'
import marketContext from './modules/market-context.store'
import softphone from './modules/softphone.store'

import softphoneSyncPlugin from './plugins/softphone-sync.plugin'
import softphoneBalancePlugin from './plugins/softphone-balance.plugin'

import { rootActions, rootMutations, rootState } from './root'

import test from './modules/test.store'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const getters = {}

export default new Vuex.Store({
  modules: {
    registration,
    'common-entities': commonEntities,
    auth,
    billing,
    campaign,
    test,
    dashboard,
    account,
    country,
    sellerOffer,
    callLogs,
    creative,
    globalSettings,
    onboarding,
    'verification-checklist': verificationChecklist,
    ringbaTokens,
    ringbaAccounts,
    ringTreeTargetRequest,
    sellerWebhooks,
    insights,
    impersonation,
    marketContext,
    softphone
  },
  strict: debug,
  plugins: debug ? [createLogger(), VuexReset(), createCache({
    timeout: 3000
  }), softphoneSyncPlugin, softphoneBalancePlugin] : [VuexReset(), createCache({
    timeout: 3000
  }), softphoneSyncPlugin, softphoneBalancePlugin],
  state: rootState(),
  mutations: rootMutations,
  actions: rootActions,
  getters
})
